import { Game } from '../lobby';

import { CreateGameSectionMobile } from 'modules/lobby-page/components';
import { LiveGamesSectionMobile } from 'modules/lobby-page/components/live-games-section';

import { useUIStore } from 'shared/store/uiStore';
import { RoomInfo } from 'shared/types/app-types';
import { CurrencyType } from 'shared/web3/utils/getCurrencyInfo';

interface IMobileViewProps {
  approveAllowanceHandler: (fullAllowance: boolean, bet: number) => void;
  startGameHandler: (bet: number, wins: number, playerB: string, currency?: CurrencyType) => void;
  joinRoomHandler: (roomId: number) => void;
  games: Game[];
  activeGames: RoomInfo[];
}

export const MobileView = ({
  approveAllowanceHandler,
  startGameHandler,
  joinRoomHandler,
  games,
  activeGames,
}: IMobileViewProps) => {
  const {
    lobby: { createGameOpen },
    setLobbyCreateGameOpen,
  } = useUIStore();

  const toggleCreateGameSection = () => setLobbyCreateGameOpen(!createGameOpen);
  return (
    <div className="relative flex min-h-[100vh] w-full flex-col">
      {createGameOpen && (
        <CreateGameSectionMobile
          openLiveGames={toggleCreateGameSection}
          approveAllowanceHandler={approveAllowanceHandler}
          startGameHandler={startGameHandler}
        />
      )}
      {!createGameOpen && (
        <LiveGamesSectionMobile
          openCreateGame={toggleCreateGameSection}
          joinRoomHandler={joinRoomHandler}
          startGameHandler={startGameHandler}
          games={games}
          activeGames={activeGames}
        />
      )}
    </div>
  );
};
